import { render, staticRenderFns } from "./DeskMapPreview.vue?vue&type=template&id=cca12da4&scoped=true&"
import script from "./DeskMapPreview.vue?vue&type=script&lang=js&"
export * from "./DeskMapPreview.vue?vue&type=script&lang=js&"
import style0 from "./DeskMapPreview.vue?vue&type=style&index=0&id=cca12da4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca12da4",
  null
  
)

export default component.exports